/**
 * Color constants for the UI, sourced from the canonical SCSS variables
 * in ui/scss/_bp-overrides.scss via the ICSS :export in colors.module.scss.
 *
 * Do NOT hardcode hex values here — update _bp-overrides.scss instead.
 */
import * as scss from './colors.module.scss';

// Brand
export const BRAND = scss.brand;
export const BRAND_TEXT = scss.brandText;
export const BRAND_BLACK = scss.brandBlack;
export const BRAND_WHITE = scss.brandWhite;

// Base colors
export const PURPLE = scss.purple;
export const RED = scss.red;
export const YELLOW = scss.yellow;
export const GREEN = scss.green;
export const BLUE = scss.blue;

// Blueprint Primary Intent (blue scale)
export const BLUE1 = scss.blue1;
export const BLUE2 = scss.blue2;
export const BLUE3 = scss.blue3;
export const BLUE4 = scss.blue4;
export const BLUE5 = scss.blue5;

// Blueprint Success Intent (green scale)
export const GREEN1 = scss.green1;
export const GREEN2 = scss.green2;
export const GREEN3 = scss.green3;
export const GREEN4 = scss.green4;
export const GREEN5 = scss.green5;

// Blueprint Warning Intent (orange scale)
export const ORANGE1 = scss.orange1;
export const ORANGE2 = scss.orange2;
export const ORANGE3 = scss.orange3;
export const ORANGE4 = scss.orange4;
export const ORANGE5 = scss.orange5;

// Blueprint Danger Intent (red scale)
export const RED1 = scss.red1;
export const RED2 = scss.red2;
export const RED3 = scss.red3;
export const RED4 = scss.red4;
export const RED5 = scss.red5;

// Gray scale
export const BLACK = scss.black;
export const WHITE = scss.white;
export const GRAY1 = scss.gray1;
export const GRAY2 = scss.gray2;
export const GRAY3 = scss.gray3;
export const GRAY4 = scss.gray4;
export const GRAY5 = scss.gray5;
export const LIGHT_GRAY1 = scss.lightGray1;
export const LIGHT_GRAY3 = scss.lightGray3;
export const LIGHT_GRAY5 = scss.lightGray5;

/** Helper to create rgba string from hex + alpha */
function rgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Chart-specific derived colors
 * Used for data visualization markers and plot bands
 */
export const CHART = {
  // Default series color
  SERIES: BRAND_BLACK,
  // Marker colors for conditional data points
  DANGER: RED3,
  WARNING: ORANGE3,
  NORMAL: BRAND_BLACK,
  // Plot band background for threshold/danger zones
  PLOT_BAND_DANGER: rgba(RED5, 0.15),
  // Heatmap
  HEATMAP_MIN: WHITE,
  HEATMAP_MAX: BLUE3,
  // Report future zone
  FUTURE_BAND: BRAND,
  FUTURE_TEXT: WHITE
};
